import { type RefObject, useEffect, useRef } from "react";

/**
 * active が true の間、dep が変わるたびに対象 textarea を末尾へ自動スクロールする.
 * AI 生成のストリーミング表示で、逐次流れてくるテキストを常に見えるようにするのに使う.
 * @param {boolean} active スクロールを有効にするか (例: 生成中)
 * @param {unknown} dep スクロールを再実行するトリガ (例: 本文テキスト)
 * @return {RefObject<HTMLTextAreaElement>} 対象 textarea に渡す ref
 */
export function useScrollToBottomWhile(
  active: boolean,
  dep: unknown,
): RefObject<HTMLTextAreaElement> {
  const ref = useRef<HTMLTextAreaElement>(null);
  // dep は値を参照しないが、更新のたびに末尾へ再スクロールさせる意図的なトリガ
  // biome-ignore lint/correctness/useExhaustiveDependencies: dep is an intentional re-scroll trigger
  useEffect(() => {
    if (!active) return;
    const el = ref.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [active, dep]);
  return ref;
}
